import React, { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import PropTypes from "prop-types";
import moment from "moment";
import { CommonDatePicker, ContainerDatePicker } from "../inputCommon";
import { CommonText } from "../TextCommon";
import _ from "lodash";
import { ConfigProvider } from "antd";
import vi from "antd/lib/locale/vi_VN";
const format = "DD/MM/YYYY";

function IDatePicker(props) {
  const {
    value,
    control,
    name,
    errors,
    label,
    required,
    disabled,
    onChange,
    placeholder,
  } = props;
  const handleChange = (value, field) => {
    field.onChange(value);
    onChange && onChange(value);
  };
  return (
    <ContainerDatePicker>
      {label && (
        <CommonText
          className={"form-label" + (required && " star-red-required")}
        >
          {label}
        </CommonText>
      )}
      {control ? (
        <>
          <Controller
            render={({ field }) => {
              return (
                <ConfigProvider locale={vi}>
                  <CommonDatePicker
                    key={field.value}
                    disabled={disabled}
                    name={field.name}
                    defaultValue={field.value && moment(field.value)}
                    format={format}
                    placeholder={placeholder}
                    onChange={value => handleChange(value, field)}
                  />
                </ConfigProvider>
              );
            }}
            {...props}
          />
          {_.get(errors, name) && (
            <CommonText level={0} color={"red"} style={{ margin: 0 }}>
              {_.get(errors, name)?.message}
            </CommonText>
          )}
        </>
      ) : (
        <ConfigProvider locale={vi}>
          <CommonDatePicker
            placeholder={placeholder}
            format={format}
            defaultValue={value && moment(value)}
            onChange={onChange}
          />
        </ConfigProvider>
      )}
    </ContainerDatePicker>
  );
}
IDatePicker.propTypes = {
  value: PropTypes.any,
  name: PropTypes.string,
  control: PropTypes.object,
  onChange: PropTypes.func,
  getValues: PropTypes.func,
  errors: PropTypes.object,
  disabled: PropTypes.bool,
  required: PropTypes.any,
  label: PropTypes.string,
  placeholder: PropTypes.string,
};
export default IDatePicker;
